import axios from "./axios";

export const inventoryStoragesApi = {
  // Get all inventory storages
  getInventoryStorages: async (params = {}) => {
    return axios.get("/inventory_storages", { params })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error.response?.data || error);
      });
  },

  // Get a single inventory storage by ID
  getInventoryStorage: async (id) => {
    return axios.get(`/inventory_storages/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error.response?.data || error);
      });
  },

  // Create a new inventory storage
  createInventoryStorage: async (data) => {
    return axios.post("/inventory_storages", {
      inventory_storage: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error.response?.data || error);
      });
  },

  // Update an existing inventory storage
  updateInventoryStorage: async (id, data) => {
    return axios.put(`/inventory_storages/${id}`, {
      inventory_storage: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error.response?.data || error);
      });
  },

  // Delete an inventory storage
  deleteInventoryStorage: async (id) => {
    return axios.delete(`/inventory_storages/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error.response?.data || error);
      });
  },
};
